import { createRouter, createWebHistory } from 'vue-router'
import { useTokenStore } from '@/stores/token'

import setPageTitle     from '@/helpers/setPageTitle'

import ViewHome         from '@/views/ViewHome.vue'
import ViewAuth         from '@/views/ViewAuth.vue'
import ViewCars         from '@/views/ViewCars.vue'
import ViewCar          from '@/views/ViewCar.vue'
import ViewUsers        from '@/views/ViewUsers.vue'
import ViewUser         from '@/views/ViewUser.vue'
// import ViewProfile      from '@/views/ViewProfile.vue'
import ViewFirmwares    from '@/views/ViewFirmwares.vue'
import ViewFirmware     from '@/views/ViewFirmware.vue'

import UTACarInfo       from '@/components/car/UTACarInfo.vue'
import UTACarEcus       from '@/components/car/UTACarEcus.vue'
import UTACarEcusList   from '@/components/car/ecus/UTAEcusList.vue'
import UTACarEcusGNSS   from '@/components/car/ecus/UTAEcusGNSS.vue'
import UTACarEcusEcu    from '@/components/car/ecus/UTAEcusEcu.vue'
import UTACarMapWrapper from '@/components/car/UTACarMapWrapper.vue'
import UTACarAreas      from '@/components/car/UTACarAreas.vue'
import UTACarRights     from '@/components/car/UTACarRights.vue'
import UTACarEvents     from '@/components/car/UTACarEvents.vue'
import UTACarHistory    from '@/components/car/UTACarHistory.vue'
import UTACarStates     from '@/components/car/UTACarStates.vue'
import UTACarTrips      from '@/components/car/UTACarTrips.vue'

import UTAUserInfo      from '@/components/user/UTAUserInfo.vue'
import UTAUserCars      from '@/components/user/UTAUserCars.vue'
import UTAUserLogs      from '@/components/user/UTAUserLogs.vue'
import UTAUserPass      from '@/components/user/UTAUserPass.vue'

import UTAAuth          from '@/components/auth/UTAAuth.vue'
import UTARegistration  from '@/components/auth/UTARegistration.vue'
import UTAForgot        from '@/components/auth/UTAForgot.vue'

import UTACertificates  from '@/components/UTACertificates.vue'
import UTACertificate   from '@/components/UTACertificate.vue'

import UTATest   from '@/components/UTATest.vue'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            name: 'home',
            component: ViewHome, 
            meta: {
                onlyAuth: true
            }
        }, 
        {
            path: '/auth',
            name: 'auth',
            component: ViewAuth, 
            meta: {},
            children: [
                {
                    path: '/auth',
                    name: 'auth-form',
                    component: UTAAuth, 
                    meta: {
                        onlyNotAuth: true,
                        breadcrumbs: [
                            { name: 'MENU_MAIN', link: '/' },
                            { name: 'MENU_AUTH' }
                        ]
                    }
                }, 
                {
                    path: '/registration',
                    name: 'registration',
                    component: UTARegistration, 
                    meta: {
                        onlyNotAuth: true,
                        breadcrumbs: [
                            { name: 'MENU_MAIN', link: '/' },
                            { name: 'MENU_REGISTRATION' }
                        ]
                    }
                }, 
                {
                    path: '/forgot',
                    name: 'forgot',
                    component: UTAForgot, 
                    meta: {
                        onlyNotAuth: true,
                        breadcrumbs: [
                            { name: 'MENU_MAIN', link: '/' },
                            { name: 'MENU_FORGOT' }
                        ]
                    }
                }
            ]
        }, 
        {
            path: '/cars',
            name: 'cars',
            component: ViewCars, 
            meta: {
                onlyAuth: true,
                breadcrumbs: [
                    { name: 'MENU_MAIN', link: '/' },
                    { name: 'MENU_CARS' }
                ]
            }
        }, 
        {
            path: '/cars/:uuid',
            name: 'car', 
            component: ViewCar, 
            props: true, 
            children: [
                {
                    path: '/cars/:uuid',
                    name: 'car-info',
                    props: true,
                    component: UTACarInfo, 
                    meta: {
                        onlyAuth: true,
                        breadcrumbs: [
                            { name: 'MENU_MAIN', link: '/' },
                            { name: 'MENU_CARS', link: '/cars' },
                            { name: 'MENU_CAR', params: 'uuid' }
                        ]
                    }
                }, 
                {
                    path: '/cars/:uuid/ecus',
                    name: 'view_ecus',
                    props: true,
                    component: UTACarEcus,
                    meta: {
                        onlyAuth: true,
                        breadcrumbs: [
                            { name: 'MENU_MAIN', link: '/' },
                            { name: 'CARS', link: '/cars' },
                            { name: 'MENU_CAR', link: '/cars/:uuid', params: 'uuid'},
                            { name: 'MENU_ECUS' }
                        ]
                    },
                    children: [{
                        path: '',
                        name: '/cars/:uuid/ecus_list',
                        props: true,
                        component: UTACarEcusList,
                        meta: {
                            onlyAuth: true,
                            breadcrumbs: [
                                { name: 'MENU_MAIN', link: '/' },
                                { name: 'CARS', link: '/cars' },
                                { name: 'MENU_CAR', link: '/cars/:uuid', params: 'uuid' },
                                { name: 'MENU_CAR_DIAG' }
                            ]
                        }
                    }, {
                        path: '/cars/:uuid/ecus/:ecuName',
                        name: 'ecus_ecu',
                        props: true,
                        component: UTACarEcusEcu,
                        meta: {
                            onlyAuth: true,
                            breadcrumbs: [
                                { name: 'MENU_MAIN', link: '/' },
                                { name: 'CARS', link: '/cars' },
                                { name: 'MENU_CAR', link: '/cars/:uuid', params: 'uuid'  },
                                { name: 'MENU_CAR_DIAG', link: '/cars/:uuid/ecus' },
                                { name: 'MENU_CAR_ECU', params: 'ecuName' }
                            ]
                        }
                    }, {
                        path: '/cars/:uuid/ecus/GNSS',
                        name: 'ecus_gnss',
                        props: true,
                        component: UTACarEcusGNSS,
                        meta: {
                            onlyAuth: true,
                            breadcrumbs: [
                                { name: 'MENU_MAIN', link: '/' },
                                { name: 'CARS', link: '/cars' },
                                { name: 'MENU_CAR', link: '/cars/:uuid', params: 'uuid'  },
                                { name: 'MENU_CAR_DIAG', link: '/cars/:uuid/ecus' },
                                { name: 'MENU_CAR_GNSS' }
                            ]
                        }
                    }]
                }, 
                {
                    path: '/cars/:uuid/map',
                    name: 'map',
                    props: true, 
                    component: UTACarMapWrapper,
                    meta: {
                        onlyAuth: true,
                        breadcrumbs: [
                            { name: 'MENU_MAIN', link: '/' },
                            { name: 'MENU_CARS', link: '/cars' },
                            { name: 'MENU_CAR', link: '/cars/:uuid', params: 'uuid' },
                            { name: 'MENU_CAR_MAP', params: 'uuid' }
                        ]
                    }
                }, 
                {
                    path: '/cars/:uuid/areas',
                    name: 'car-areas',
                    props: true, 
                    component: UTACarAreas,
                    meta: {
                        onlyAuth: true,
                        breadcrumbs: [
                            { name: 'MENU_MAIN', link: '/' },
                            { name: 'MENU_CARS', link: '/cars' },
                            { name: 'MENU_CAR', link: '/cars/:uuid', params: 'uuid' },
                            { name: 'MENU_CAR_AREAS', params: 'uuid' }
                        ]
                    }
                }, 
                {
                    path: '/cars/:uuid/states',
                    name: 'states',
                    props: true, 
                    component: UTACarStates,
                    meta: {
                        onlyAuth: true,
                        breadcrumbs: [
                            { name: 'MENU_MAIN', link: '/' },
                            { name: 'MENU_CARS', link: '/cars' },
                            { name: 'MENU_CAR', link: '/cars/:uuid', params: 'uuid' },
                            { name: 'MENU_CAR_STATES', params: 'uuid' }
                        ]
                    }
                }, 
                {
                    path: '/cars/:uuid/rights',
                    name: 'rights',
                    props: true, 
                    component: UTACarRights,
                    meta: {
                        onlyAuth: true,
                        breadcrumbs: [
                            { name: 'MENU_MAIN', link: '/' },
                            { name: 'MENU_CARS', link: '/cars' },
                            { name: 'MENU_CAR', link: '/cars/:uuid', params: 'uuid' },
                            { name: 'MENU_CAR_RIGHTS', params: 'uuid' }
                        ]
                    }
                }, 
                {
                    path: '/cars/:uuid/events',
                    name: 'events',
                    props: true, 
                    component: UTACarEvents,
                    meta: {
                        onlyAuth: true,
                        breadcrumbs: [
                            { name: 'MENU_MAIN', link: '/' },
                            { name: 'MENU_CARS', link: '/cars' },
                            { name: 'MENU_CAR', link: '/cars/:uuid', params: 'uuid' },
                            { name: 'MENU_CAR_EVENTS', params: 'uuid' }
                        ]
                    }
                }, 
                {
                    path: '/cars/:uuid/history',
                    name: 'history',
                    props: true, 
                    component: UTACarHistory,
                    meta: {
                        onlyAuth: true,
                        breadcrumbs: [
                            { name: 'MENU_MAIN', link: '/' },
                            { name: 'MENU_CARS', link: '/cars' },
                            { name: 'MENU_CAR', link: '/cars/:uuid', params: 'uuid' },
                            { name: 'MENU_CAR_HISTORY', params: 'uuid' }
                        ]
                    }
                },
                {
                    path: '/cars/:uuid/trips',
                    name: 'car-trips',
                    props: true, 
                    component: UTACarTrips,
                    meta: {
                        onlyAuth: true,
                        breadcrumbs: [
                            { name: 'MENU_MAIN', link: '/' },
                            { name: 'MENU_CARS', link: '/cars' },
                            { name: 'MENU_CAR', link: '/cars/:uuid', params: 'uuid' },
                            { name: 'MENU_CAR_TRIPS', params: 'uuid' }
                        ]
                    }
                }
            ]
        }, 
        {
            path: '/cars-groups',
            name: 'carsGroups',
            component: () => import('@/views/ViewCarsGroups.vue'),
            meta: {
                onlyAuth: true,
                breadcrumbs: [
                    { name: 'MENU_MAIN', link: '/' },
                    { name: 'MENU_CARS_GROUPS' }
                ]
            },
        },
        {
            path: '/cars-groups/:carsGroupUuid',
            name: 'carsGroup',
            props: true,
            component: () => import('@/views/ViewCarsGroup.vue'),
            meta: {
                onlyAuth: true,
                breadcrumbs: [
                    { name: 'MENU_MAIN', link: '/' },
                    { name: 'MENU_CARS_GROUPS', link: '/cars-groups' }, 
                    { name: 'MENU_CARS_GROUP', params: 'carsGroupUuid' }
                ]
            },
            children: [
                {
                    path: '',
                    name: 'carsGroupInfo',
                    component: () => import('@/components/groupsCars/UTACarsGroup.vue'),
                    props: true,
                    meta: {
                        onlyAuth: true,
                        breadcrumbs: [
                            { name: 'MENU_MAIN', link: '/' },
                            { name: 'MENU_CARS_GROUPS', link: '/cars-groups' }, 
                            { name: 'MENU_CARS_GROUP', params: 'carsGroupUuid' }
                        ]
                    },
                },
                {
                    path: 'cars',
                    name: 'carsGroupsCars',
                    component: () => import('@/components/groupsCars/UTACarsGroupCars.vue'),
                    props: true,
                    meta: {
                        onlyAuth: true,
                        breadcrumbs: [
                            { name: 'MENU_MAIN', link: '/' },
                            { name: 'MENU_CARS_GROUPS', link: '/cars-groups' }, 
                            { name: 'MENU_CARS_GROUP', link: '/cars-groups/:carsGroupUuid', params: 'carsGroupUuid' }, 
                            { name: 'MENU_CARS_GROUP_CARS' }
                        ]
                    },
                },
                {
                    path: 'users-groups',
                    name: 'carsGroupsUsersGroups',
                    component: () => import('@/components/groupsCars/UTACarsGroupUsersGroups.vue'),
                    props: true,
                    meta: {
                        onlyAuth: true,
                        breadcrumbs: [
                            { name: 'MENU_MAIN', link: '/' },
                            { name: 'MENU_CARS_GROUPS', link: '/cars-groups' }, 
                            { name: 'MENU_CARS_GROUP', link: '/cars-groups/:carsGroupUuid', params: 'carsGroupUuid' }, 
                            { name: 'MENU_CARS_GROUP_USERS_GROUPS' }
                        ]
                    },
                },
            ]
        },
        {
            path: '/users', 
            name: 'users', 
            component: ViewUsers, 
            meta: {
                onlyAuth: true,
                breadcrumbs: [
                    { name: 'MENU_MAIN', link: '/' },
                    { name: 'MENU_DRIVERS' },
                ]
            }
        }, 
        {
            path: '/users/create',
            name: 'user_create',
            component: () => import('@/views/ViewUserCreate.vue'),
            meta: {
                onlyAuth: true,
                breadcrumbs: [
                    { name: 'MENU_MAIN', link: '/' },
                    { name: 'MENU_DRIVERS', link: '/users' },
                    { name: 'MENU_USER_CREATE' }
                ]
            }
        },
        {
            path: '/users/:uuid', 
            name: 'user', 
            props: true, 
            component: ViewUser, 
            meta: { 

                onlyAuth: true,
                breadcrumbs: [
                    { name: 'MENU_MAIN', link: '/' },
                    { name: 'MENU_DRIVERS', link: '/users' },
                    { name: 'MENU_DRIVER' }
                ]
            }, 
            children: [ 
                { 
                    path: '', 
                    name: 'user-info', 
                    props: true, 
                    component: UTAUserInfo, 
                    meta: { 
                        onlyAuth: true,
                        breadcrumbs: [
                            { name: 'MENU_MAIN', link: '/' },
                            { name: 'MENU_DRIVERS', link: '/users' },
                            { name: 'MENU_DRIVER' },
                        ]
                    }
                }, 
                { 
                    path: '/users/:uuid/cars', 
                    name: 'user-cars', 
                    props: true, 
                    component: UTAUserCars, 
                    meta: { 
                        onlyAuth: true 
                    }
                }, 
                { 
                    path: '/users/:uuid/logs', 
                    name: 'user-logs', 
                    props: true, 
                    component: UTAUserLogs, 
                    meta: { 
                        onlyAuth: true 
                    }
                }, 
                { 
                    path: '/users/:uuid/password', 
                    name: 'user-pass', 
                    props: true, 
                    component: UTAUserPass, 
                    meta: { 
                        onlyAuth: true 
                    }
                }
            ]
        },
        // {
        //     path: '/profile', 
        //     name: 'profile', 
        //     component: ViewProfile, 
        //     meta: { 

        //         onlyAuth: true,
        //         breadcrumbs: [
        //             { name: 'MENU_MAIN', link: '/' },
        //             { name: 'MENU_PROFILE' },
        //         ]
        //     }, 
        //     children: [ 
        //         { 
        //             path: '', 
        //             name: 'profile-info', 
        //             component: UTAUserInfo, 
        //             meta: { 
        //                 onlyAuth: true,
        //                 breadcrumbs: [
        //                     { name: 'MENU_MAIN', link: '/' },
        //                     { name: 'MENU_PROFILE' },
        //                 ]
        //             }
        //         }, 
        //         { 
        //             path: '/profile/cars', 
        //             name: 'profile-cars', 
        //             component: UTAUserCars, 
        //             meta: { 
        //                 onlyAuth: true 
        //             }
        //         }, 
        //         { 
        //             path: '/profile/logs', 
        //             name: 'profile-logs', 
        //             props: true, 
        //             component: UTAUserLogs, 
        //             meta: { 
        //                 onlyAuth: true 
        //             }
        //         }, 
        //         { 
        //             path: '/profile/password', 
        //             name: 'profile-pass', 
        //             props: true, 
        //             component: UTAUserPass, 
        //             meta: { 
        //                 onlyAuth: true 
        //             }
        //         }
        //     ]
        // },
        {
            path: '/users-groups',
            name: 'usersGroups',
            component: () => import('@/views/ViewUsersGroups.vue'),
            meta: {
                onlyAuth: true,
                breadcrumbs: [
                    { name: 'MENU_MAIN', link: '/' },
                    { name: 'USERS_GROUPS' }
                ]
            }
        },
        {
            path: '/certificates',
            name: 'certificates', 
            component: UTACertificates,
            meta: {
                onlyAuth: true,
                breadcrumbs: [
                    { name: 'MENU_MAIN', link: '/' },
                    { name: 'CERTIFICATES' }
                ]
            }
        },
        {
            path: '/certificates/:imei',
            name: 'certificate', 
            component: UTACertificate, 
            props: true,
            meta: {
                onlyAuth: true,
                breadcrumbs: [
                    { name: 'MENU_MAIN', link: '/' },
                    { name: 'CERTIFICATES', link: '/certificates' },
                    { name: 'CERTIFICATE', params: 'imei' }
                ]
            }
        },
        {
            path: '/users-groups/:usersGroupUuid',
            name: 'usersGroup',
            props: true,
            component: () => import('@/views/ViewUsersGroup.vue'),
            meta: {
                onlyAuth: true,
                breadcrumbs: [
                    { name: 'MENU_MAIN', link: '/' },
                    { name: 'MENU_USERS_GROUPS', link: '/users-groups' }, 
                    { name: 'MENU_USERS_GROUP', params: 'usersGroupUuid' }
                ]
            },
            children: [
                {
                    path: '',
                    name: 'usersGroupInfo',
                    component: () => import('@/components/groupsUsers/UTAUsersGroup.vue'),
                    props: true,
                    meta: {
                        onlyAuth: true,
                        breadcrumbs: [
                            { name: 'MENU_MAIN', link: '/' },
                            { name: 'MENU_USERS_GROUPS', link: '/users-groups' }, 
                            { name: 'MENU_USERS_GROUP' }
                        ]
                    },
                },
                {
                    path: 'users',
                    name: 'usersGroupUsers',
                    component: () => import('@/components/groupsUsers/UTAUsersGroupUsers.vue'), 
                    props: true,
                    meta: {
                        onlyAuth: true,
                        breadcrumbs: [
                            { name: 'MENU_MAIN', link: '/' },
                            { name: 'MENU_USERS_GROUPS', link: '/users-groups' }, 
                            { name: 'MENU_USERS_GROUP', link: '/users-groups/:usersGroupUuid', params: 'usersGroupUuid' }, 
                            { name: 'MENU_USERS_GROUP_USERS' }
                        ]
                    },
                },
                {
                    path: 'cars',
                    name: 'usersGroupCars',
                    component: () => import('@/components/groupsUsers/UTAUsersGroupCars.vue'),
                    props: true,
                    meta: {
                        onlyAuth: true,
                        breadcrumbs: [
                            { name: 'MENU_MAIN', link: '/' },
                            { name: 'MENU_USERS_GROUPS', link: '/users-groups' }, 
                            { name: 'MENU_USERS_GROUP', link: '/users-groups/:usersGroupUuid', params: 'usersGroupUuid' }, 
                            { name: 'MENU_USERS_GROUP_CARS' }
                        ]
                    },
                },
                {
                    path: 'cars-groups',
                    name: 'usersGroupCarsGroups',
                    component: () => import('@/components/groupsUsers/UTAUsersGroupCarsGroups.vue'),
                    props: true,
                    meta: {
                        onlyAuth: true,
                        breadcrumbs: [
                            { name: 'MENU_MAIN', link: '/' },
                            { name: 'MENU_USERS_GROUPS', link: '/users-groups' }, 
                            { name: 'MENU_USERS_GROUP', link: '/users-groups/:usersGroupUuid', params: 'usersGroupUuid' }, 
                            { name: 'MENU_USERS_GROUP_CARS_GROUPS' }
                        ]
                    },
                },
            ]
        },
        {
            path: '/areas',
            name: 'areas',
            component: () => import('@/views/ViewAreas.vue'),
            meta: {
                onlyAuth: true,
                breadcrumbs: [
                    { name: 'MENU_MAIN', link: '/' },
                    { name: 'AREAS' }
                ]
            }
        },
        {
            path: '/areas/:uuid',
            name: 'area',
            component: () => import('@/views/ViewAreasEdit.vue'),
            meta: {
                onlyAuth: true,
                breadcrumbs: [
                    { name: 'MENU_MAIN', link: '/' },
                    { name: 'AREAS', link: '/areas' },
                    { name: 'AREA', params: 'uuid' }
                ]
            }
        },
        {
            path: '/areas/create',
            name: 'areas_create',
            component: () => import('@/views/ViewAreasCreate.vue'),
            meta: {
                onlyAuth: true,
                breadcrumbs: [
                    { name: 'MENU_MAIN', link: '/' },
                    { name: 'AREAS', link: '/areas' },
                    { name: 'AREA_CREATE' }
                ]
            }
        },
        {
            path: '/test',
            name: 'test', 
            component: UTATest, 
            meta: {
                onlyAuth: true,
                breadcrumbs: [
                    { name: 'MENU_MAIN', link: '/' },
                    { name: 'MENU_TEST' }
                ]
            }
        }, 
        {
            path: '/firmwares',
            name: 'firmwares', 
            component: ViewFirmwares, 
            meta: {
                onlyAuth: true,
                breadcrumbs: [
                    { name: 'MENU_MAIN', link: '/' },
                    { name: 'MENU_FIRMWARES' }
                ]
            }
        },
        {
            path: '/firmwares/:fwName',
            name: 'firmware',
            component: ViewFirmware, 
            props: true,
            meta: {
                onlyAuth: true,
                breadcrumbs: [
                    { name: 'MENU_MAIN', link: '/' },
                    { name: 'MENU_FIRMWARES', link: '/firmwares' }, 
                    { name: 'MENU_FIRMWARE', params: 'fwName'},
                ]
            }
        }, 
        {
            path: '/:catchAll(.*)',
            name: '404', 
            component: () => import('@/views/ViewError404.vue'), 
            meta: {
                onlyAuth: true
            }
        }
    ]
})

router.beforeEach((to, from, next) => {

    const tokenStore = useTokenStore()
    const access = tokenStore.access

    // Title Пользователя задается в UTAUserNavi
    if(to.name !== 'user-info' && to.name !== 'user-pass') {
        
        setPageTitle(to.meta?.breadcrumbs)
    }    

    if(to.fullPath == '/auth' && access) {

        next('/') 
        return
    }

    if(to.matched.some(record => record.meta.onlyNotAuth)) {
        
        if(access) {
            next('/') 
            return
        }
    }

    if(to.matched.some(record => record.meta.onlyAuth)) {

        if (access) {
            next() 
            return
        }

        next('/auth') 
        return
    }

    next() 
})

export default router
